import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useCreateTwoFactorSetupSkipMutation } from 'components/hooks/twoFactorMutations';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function SkipModal({ afterSetupPath, closeModal, isOpen }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.profile.twoFactorAuthentication.SkipModal',
  });

  const { t: i18nTAuthentication } = useTranslation('common', {
    keyPrefix: 'authentication',
  });

  const createTwoFactorSetupSkipMutation =
    useCreateTwoFactorSetupSkipMutation();

  const handleSkip = () => {
    createTwoFactorSetupSkipMutation.mutate(
      {},
      {
        onSuccess: () => {
          window.location.assign(afterSetupPath);
        },
        onError: () => {
          window.location.assign('/users/sign_in');
        },
      },
    );
  };

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={closeModal}
            size='md'
          >
            {i18nT('backToSetup')}
          </TextButton>
          <FilledButton
            color='mint'
            disabled={createTwoFactorSetupSkipMutation.isLoading}
            onClick={handleSkip}
          >
            {i18nTAuthentication('skipOnce')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={closeModal}
      usingWideDimensions={true}
    >
      <div className='tw-p-8' data-element-name='content'>
        <h2 className='tw-m-0 tw-p-0 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nT('warningHeader')}
        </h2>
        <p className='tw-text-sm tw-mt-4 tw-text-grey-700'>
          {i18nT('warningBody1')}
        </p>
        <p className='tw-text-sm tw-mt-2 tw-text-grey-700'>
          {i18nT('warningBody2')}
        </p>
      </div>
    </ModalBox>
  );
}

SkipModal.propTypes = {
  afterSetupPath: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
